import { jsx as _jsx } from "react/jsx-runtime";
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { LocaleProvider } from './context/LocaleContext';
import './styles/global.css';
const container = document.getElementById('root');
if (container) {
    const root = createRoot(container);
    root.render(_jsx(LocaleProvider, { children: _jsx(App, {}) }));
}
